module.exports = __webpack_public_path__ + "img/naotu_3.a268eaeb.png";